import {gql} from "@apollo/client"

export const chorusB2GProvidersList = gql`
    query chorusB2GProvidersList($login: String!, $password: String!, $serverType: ChorusServerType!) {
        chorusB2GProvidersList(login: $login, password: $password, serverType: $serverType) {
            providerId
            providerName
        }
    }
`

export const getAllNatures = gql`
    query natureList($params: NatureQueryParams, $after: String, $language: Language) {
        contactFunctionSystemList(language: $language) {
            edges {
                id
                name
            }
        }
        thirdPartyTypeSystemList(language: $language) {
            edges {
                id
                name
            }
        }
        natureList(params: $params, after: $after, language: $language) {
            edges {
                id
                cycle
                code
                label
                natureType
                metadataConfigs {
                    metadataCode
                    dataType
                    isMandatory
                    isFilterable
                    isVisible
                    isEditable
                    isArchivable
                    defaultValue
                    expectedFormat
                }
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
`
export const clickedLinkDocumentItems = gql`
    query clickedLinkDocumentItems($id: String!) {
        clickedLinkDocumentItems(id: $id) {
            id
            jobId
            jobMessageId
            documentName
            expirationDate
            isCountExpired
            content
            documentId
            tenantId
        }
    }
`

export const readDocument = gql`
    mutation readDocument($tenantId: String!, $documentId: String!, $jobId: String!, $jobMessageId: String!) {
        readDocument(tenantId: $tenantId, documentId: $documentId, jobId: $jobId, jobMessageId: $jobMessageId)
    }
`

export const getUserTenantQuery = gql`
    query userItems($idList: [String!]!) {
        userItems(idList: $idList) {
            roles {
                profile
                lastConnectionDate
            }
        }
    }
`

export const rightInitialValueListDomainQuery = gql`
    query rightInitialValueList($profile: UserProfile!, $tenantId: String) {
        rightInitialValueList(profile: $profile) {
            edges {
                right
                category
                subCategory
                actionType
                value: initialValue
            }
        }
        serviceList(tenantId: $tenantId) {
            edges {
                id
                name
            }
        }
    }
`
